import { supabase } from "../lib/supabase";
import { requireActiveWorkspaceId } from "./workspaceService";

export async function getQuotes() {
  const workspaceId = await requireActiveWorkspaceId();

  const { data, error } = await supabase
    .from("quotes")
    .select(`
      *,
      customers (
        id,
        name,
        email,
        phone,
        city,
        type
      )
    `)
    .eq("workspace_id", workspaceId)
    .order("created_at", { ascending: false });

  if (error) throw error;

  return data || [];
}

export async function getQuoteById(quoteId) {
  const workspaceId = await requireActiveWorkspaceId();

  const { data, error } = await supabase
    .from("quotes")
    .select(`
      *,
      customers (
        id,
        name,
        email,
        phone,
        city,
        type
      )
    `)
    .eq("id", quoteId)
    .eq("workspace_id", workspaceId)
    .single();

  if (error) throw error;

  return data;
}

export async function createQuote(quote) {
  const workspaceId = await requireActiveWorkspaceId();

  const payload = {
    ...quote,
    workspace_id: workspaceId,
  };

  const { data, error } = await supabase
    .from("quotes")
    .insert(payload)
    .select("*")
    .single();

  if (error) throw error;

  return data;
}

export async function updateQuote(quoteId, patch) {
  const workspaceId = await requireActiveWorkspaceId();

  const safePatch = {
    ...patch,
    workspace_id: workspaceId,
  };

  const { data, error } = await supabase
    .from("quotes")
    .update(safePatch)
    .eq("id", quoteId)
    .eq("workspace_id", workspaceId)
    .select("*")
    .single();

  if (error) throw error;

  return data;
}

export async function deleteQuote(quoteId) {
  const workspaceId = await requireActiveWorkspaceId();

  const { error } = await supabase
    .from("quotes")
    .delete()
    .eq("id", quoteId)
    .eq("workspace_id", workspaceId);

  if (error) throw error;

  return true;
}

export async function getQuoteVersions(quoteId) {
  const workspaceId = await requireActiveWorkspaceId();

  const { data, error } = await supabase
    .from("quote_versions")
    .select("*")
    .eq("quote_id", quoteId)
    .eq("workspace_id", workspaceId)
    .order("created_at", { ascending: false });

  if (error) throw error;

  return data || [];
}